import { IConfigsType } from '../../types'

const wingitnorthOutliers: IConfigsType = {
  wingitnorth: {
    '/:brand/outliers': {
      variables: ['corporateGroup'],
      flashTitle: {
        type: 'title',
        title: 'Outliers',
      },
      groupFilter: {
        api: 'corporateFilter',
      },
      dateFilter: {
        types: ['week', 'this_week'],
        defaultType: 'this_week',
      },
      downloadFlashTable: {
        type: 'download-csv',
        api: 'wingitnorthOutliers',
        fileName: 'getexpo-wingitnorth-outliers',
        fileNameFn: (date: string) => `getexpo-wingitnorth-outliers-${date}`,
        message: 'Download Outliers as CSV',
        fields: [
          'groupInfo',
          {
            key: 'totalLaborVarianceHours',
            title: 'Wkly Store Actual to Scheduled Labor Hours',
          },
          {
            key: 'avtPercent',
            title: 'Food Cost Variance %',
          },
          {
            key: 'cogsPercent',
            title: 'Actual Food Cost %',
          },
          {
            key: 'laborOvertimeHours',
            title: 'Overtime',
          },
          {
            key: 'cashOverShort',
            title: 'Cash Over Short',
          },
          {
            key: 'discountCompsPercent',
            title: 'Discount',
          },
          {
            key: 'voidsPercent',
            title: 'Voids',
          },
          {
            key: 'netSalesPercentageDiffToLastYear',
            title: 'SSS%',
          },
          {
            key: 'netSalesPercentageDiffTo7DaysAgo',
            title: 'Week over Week Sales Change',
          },
          {
            key: 'checkAverage',
            title: 'Check Average',
          },
        ],
      },
      outliersTable: {
        type: 'table-v2',
        api: 'wingitnorthOutliers',
        pagination: {
          pageSize: 20,
        },
        sorting: [
          {
            id: '<%- corporateGroup?.tableColumns[0].key %>',
            desc: true,
          },
        ],
        row: { background: '<%- index % 2 ? colors.Porcelain : "" %>' },
        columns: [
          {
            key: '<%- JSON(corporateGroup?.tableColumns) %>',
            hide: '<%- _.isUndefined(corporateGroup) %>',
            sortable: true,
            width: '150px',
          },
          {
            key: 'totalLaborVarianceHours',
            title: 'Wkly Store Actual to Scheduled Labor Hours',
            decimal: 2,
            sortable: true,
            color: '<%- value >= 30 ? "red" : "black" %>',
            width: '100px',
          },
          {
            key: 'avtPercent',
            title: 'Food Cost Variance %',
            decimal: 2,
            sortable: true,
            color: '<%- value >= 1.5 ? "red" : "black" %>',
            width: '100px',
          },
          {
            key: 'cogsPercent',
            title: 'Actual Food Cost %',
            decimal: 2,
            sortable: true,
            color:
              '<%- value >= 29 ? "red" : value < 25 ? "black" : "orange" %>',
            width: '100px',
          },
          {
            key: 'laborOvertimeHours',
            title: 'Overtime',
            decimal: 2,
            sortable: true,
            color: '<%- value >= 15 ? "red" : "black" %>',
            width: '100px',
          },
          {
            key: 'cashOverShort',
            title: 'Cash Over Short',
            sortable: true,
            decimal: 2,
            color: '<%- value >= 10000 ? "red" : "black" %>',
            width: '100px',
          },
          {
            key: 'discountCompsPercent',
            title: 'Discount',
            decimal: 2,
            sortable: true,
            color: '<%- value >= 2 ? "red" : "black" %>',
            width: '100px',
          },
          {
            key: 'voidsPercent',
            title: 'Voids',
            decimal: 2,
            sortable: true,
            color: '<%- value >= 0.5 ? "red" : "black" %>',
            width: '100px',
          },
          {
            key: 'netSalesPercentageDiffToLastYear',
            title: 'SSS%',
            decimal: 2,
            sortable: true,
            color: 'black',
            width: '100px',
          },
          {
            key: 'netSalesPercentageDiffTo7DaysAgo',
            title: 'Week over Week Sales Change',
            decimal: 2,
            sortable: true,
            color: 'black',
            width: '100px',
          },
          {
            key: 'checkAverage',
            title: 'Check Average',
            decimal: 2,
            sortable: true,
            color:
              '<%- value >= 3000 ? "black" : value < 2000 ? "red" : "orange" %>',
            width: '100px',
          },
        ],
      },
    },
  },
}

export default wingitnorthOutliers
